<script lang="ts">
	import { fetchCount$ } from "$lib/serv/core/auth";
</script>

{#if $fetchCount$ > 0}
	<article class="load-container">
		<div class="load-runner"></div>
	</article>
{/if}

<style lang="scss">
	@use 'color';

	@keyframes run {
    0%   { width: 0% }
    25%  { width: 50% }
    50%  { width: 98% }
    75%  { width: 50% }
    100% { width: 0% }
	}

	.load-container {
		position: absolute;
		left: 0;
		top: 0;
		right: 0;
		width: 100%;
		height: 1px;
		z-index: 5;
		.load-runner {
			width: 0%;
			height: 100%;
			background: color.$primary;
			margin: 0 auto;
			animation: run 2.4s infinite linear;
		}
	}
</style>